import React, { useState } from "react";
import { useSite } from "../context/SiteContext";
import { mediaUrl } from "../lib/api";
import { X, Smartphone, Download } from "lucide-react";

const STORAGE_KEY = "efsane_app_notice_closed";

export function AppDownloadNotice() {
  const { settings } = useSite();
  const [closed, setClosed] = useState(() => {
    try {
      return localStorage.getItem(STORAGE_KEY) === "1";
    } catch {
      return false;
    }
  });

  if (closed) return null;

  const close = () => {
    try {
      localStorage.setItem(STORAGE_KEY, "1");
    } catch {}
    setClosed(true);
  };

  return (
    <div
      data-testid="app-download-notice"
      className="relative flex items-center gap-3 px-4 py-2 border-b border-white/10"
      style={{ background: "linear-gradient(90deg, #1a1a1a 0%, #2a0505 100%)" }}
    >
      <img
        src={mediaUrl(settings.logo_url) || "/logo.png"}
        alt={settings.site_name}
        className="h-7 w-7 rounded-lg object-contain shrink-0 shadow-[0_0_12px_rgba(229,9,20,0.5)]"
      />
      <div className="flex items-center gap-1.5 min-w-0 flex-1">
        <Smartphone size={15} className="text-[#E50914] shrink-0 hidden sm:block" />
        <p className="text-xs sm:text-sm text-gray-200 truncate">
          <span className="font-semibold text-white">efsane</span> artık Android uygulaması olarak da mevcut!
        </p>
      </div>
      <a
        data-testid="app-download-notice-button"
        href="/efsane.apk"
        download="efsane.apk"
        className="shrink-0 inline-flex items-center gap-1.5 bg-[#E50914] hover:bg-[#F40612] text-white text-xs sm:text-sm font-semibold px-3 py-1.5 rounded-md transition-all active:scale-95"
      >
        <Download size={15} /> İndir
      </a>
      <button
        data-testid="app-download-notice-close"
        onClick={close}
        aria-label="Kapat"
        className="shrink-0 text-white/60 hover:text-white transition-colors p-1 -mr-1"
      >
        <X size={18} />
      </button>
    </div>
  );
}
